import { gql } from '@apollo/client';

export const CREATE_FAVORITE_FIELDS_MUTATION = gql`
  mutation CreateFavoriteFieldOperation(
    $fieldName: String!
    $fieldType: FavoriteFieldType!
  ) {
    createFavoriteField(
      applyToAllObjectTypes: true
      associatedObjectTypes: []
      fieldName: $fieldName
      fieldType: $fieldType
    ) {
      data {
        applyToAllObjectTypes
        associatedObjectTypes
        fieldName
        fieldType
        id
      }
    }
  }
`;

export const DELETE_FAVORITE_FIELDS_MUTATION = gql`
  mutation DeleteFavoriteFieldOperation($id: ID!) {
    deleteFavoriteField(id: $id) {
      ok
    }
  }
`;
